define("settings/controllers/groups/group/social_profiles", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency"], function (_exports, _asyncArrowRuntime, _controller, _object, _service, _tracking, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19;
  /* eslint-disable @latermedia/later-linting/use-snake-case-query-params */
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let SocialProfilesController = _exports.default = (_dec = (0, _service.inject)('social/instagram-auth'), _dec2 = (0, _object.computed)('instagramAuth.canShowInstagramAuthStatus'), (_class = class SocialProfilesController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "mavelyAuth", _descriptor5, this);
      _initializerDefineProperty(this, "router", _descriptor6, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor7, this);
      _initializerDefineProperty(this, "instagramAuth", _descriptor8, this);
      _initializerDefineProperty(this, "queryParams", _descriptor9, this);
      _initializerDefineProperty(this, "showContactUsModal", _descriptor10, this);
      _initializerDefineProperty(this, "showCreatorProfile", _descriptor11, this);
      _initializerDefineProperty(this, "showCredentialsError", _descriptor12, this);
      _initializerDefineProperty(this, "showInstagramAuthStatus", _descriptor13, this);
      _initializerDefineProperty(this, "showProfileAddedModal", _descriptor14, this);
      _initializerDefineProperty(this, "showProfileCategorizationModal", _descriptor15, this);
      _initializerDefineProperty(this, "showTiktokProfileMismatched", _descriptor16, this);
      _initializerDefineProperty(this, "source", _descriptor17, this);
      _initializerDefineProperty(this, "editingIdentityId", _descriptor18, this);
      _initializerDefineProperty(this, "editingIdentityName", _descriptor19, this);
      _defineProperty(this, "connectMavely", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (identity) {
          const profileId = yield this.mavelyAuth.handleAuthenticationPopup.perform(identity);
          if (profileId) {
            yield this.mavelyAuth.fetchProfiles.perform(identity);
          }
        }
      }), null, "connectMavely", null));
      _defineProperty(this, "disconnectMavely", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (identity, profile) {
          yield this.mavelyAuth.disconnect.perform({
            area: 'social-profile-settings',
            socialIdentity: identity,
            group: this.group,
            profile
          });
        }
      }), null, "disconnectMavely", null));
      _defineProperty(this, "deleteSocialProfile", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (socialProfile, group) {
          yield fetch(`/api/v2/social_profiles/${socialProfile.id}.json`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json'
            }
          });
          group.get('socialIdentities').removeObject(socialProfile);
          this.alerts.success(this.intl.t('account.controllers.groups.social_set_deleted'));
        }
      }), null, "deleteSocialProfile", null));
      _defineProperty(this, "hightlightComment", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (element) {
          element.classList.add('u--glow');
          yield (0, _emberConcurrency.timeout)(3000);
          element.classList.remove('u--glow');
        }
      }), null, "hightlightComment", null));
      _defineProperty(this, "saveIdentityName", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (identity) {
          // Update the identity displayName (empty string will clear the custom name)
          const trimmedName = this.editingIdentityName.trim();
          identity.displayName = trimmedName || null;
          try {
            // Save the identity using Ember Data
            yield identity.save();

            // Clear editing state
            this.editingIdentityId = null;
            this.editingIdentityName = '';

            // Show success message
            this.alerts.success(this.intl.t('alerts.account.social_identity.name_updated.message'), {
              title: this.intl.t('alerts.account.social_identity.name_updated.title')
            });
          } catch (error) {
            // Rollback changes on error
            identity.rollbackAttributes();

            // Clear editing state even on error
            this.editingIdentityId = null;
            this.editingIdentityName = '';

            // Show error message
            this.alerts.alert(this.intl.t('alerts.account.social_identity.name_update_failed'), {
              title: this.intl.t('alerts.generic_error_message')
            });
          }
        }
      }), null, "saveIdentityName", null));
    }
    get socialProfiles() {
      // Note: Parent route may delete the group
      if (this.group.isDestroying || this.group.isDestroyed) {
        return [];
      }
      return this.group.socialProfiles;
    }
    get isAccountOwner() {
      return this.auth.currentUserModel.isAccountOwner;
    }
    get numUsedSocialSets() {
      return this.auth.currentAccount.socialIdentitiesCount || 0;
    }
    get socialSetsRemaining() {
      const remaining = (this.totalSocialSets || 1) - this.numUsedSocialSets;
      return Math.max(remaining, 0);
    }
    get totalSocialSets() {
      return this.auth.currentAccount.totalSocialSets || 1;
    }
    get groupSlug() {
      return this.group.slug;
    }
    get anySocialProfileErrors() {
      return this.socialProfiles.any(item => item.hasError);
    }
    get linkedinCredentialRefreshError() {
      const errorProfile = this.socialProfiles.find(item => item.isLinkedin && item.credentialRefreshError);
      return errorProfile?.credentialRefreshError;
    }
    get socialProfileErrorText() {
      return this.anySocialProfileErrors ? this.intl.t('account.social_accounts.errors.general') : null;
    }

    /**
     * Mobile subscribers in an empty group with no remaining social sets are
     * blocked from the add profile modal to avoid displaying an empty modal.
     */
    get isMobileSubscriptionBlockedFromAddProfile() {
      return this.socialProfiles.length === 0 && !this.socialSetsRemaining && this.isMobileSubscription;
    }
    get tiktokProfile() {
      return this.socialProfiles.find(profile => profile.id === this.showTiktokProfileMismatched);
    }
    get isEligibleForTrial() {
      return this.group.get('account.canTrialPlan');
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get canAccessOCE() {
      return this.auth.currentAccount.rolloutOcePhase1;
    }
    mavelyProfilesForIdentity(identity) {
      // MC-only: show a profile under this SI's connected-accounts list only when
      // the MC is actually on THIS SI. SIMP-fallback profiles surface with
      // connectionId populated (from another SI's per-SI fetch) but a different
      // socialIdentityId — they must NOT be shown here as if this SI owned them.
      return (this.mavelyAuth.mavelyProfiles.get(identity) ?? []).filter(profile => profile.socialIdentityId === identity.id);
    }
    get canShowInstagramAuthStatus() {
      return this.instagramAuth.canShowInstagramAuthStatus;
    }
    deleteCreatorSocialSet(socialProfile, group) {
      this.dialogManager.confirmation(this.intl.t('account.controllers.groups.confirm_social_set_deletion.title'), {
        description: this.intl.t('account.controllers.groups.confirm_social_set_deletion.description'),
        confirmButton: this.intl.t('shared_words.delete')
      }).then(confirmDelete => {
        if (confirmDelete) {
          this.deleteSocialProfile.perform(socialProfile, group);
        }
      });
    }
    setup() {
      this.instagramAuth.updateCache();
      this.showErrors();
    }
    showErrors() {
      if (this.showCredentialsError && this.linkedinCredentialRefreshError) {
        this.alerts.alert(this.linkedinCredentialRefreshError);
        this.showCredentialsError = false;
      }
    }
    scrollTo(element) {
      this.scrollToTag(`#social-identity-${element}`);
    }
    goToCategorization() {
      this.set('showProfileCategorizationModal', true);
      this.set('showProfileAddedModal', false);
    }
    goToAnalytics(socialProfile) {
      this.set('showProfileAddedModal', false);
      this.router.transitionTo('cluster.analytics.profile.instagram.overview', this.groupSlug, socialProfile.urlName);
    }
    goToCalendar() {
      this.set('showProfileAddedModal', false);
      this.router.transitionTo('cluster.schedule.calendar', this.groupSlug);
    }
    closeTikTokProfileMismatch() {
      this.set('showTiktokProfileMismatch', false);
      this.router.transitionTo('account.groups.group.social_profiles.edit', this.auth.currentGroup.id, this.tiktokProfile.id, {
        queryParams: {
          tiktok_profile_mismatched: undefined
        }
      });
    }
    cancelTikTokProfileMismatch() {
      this.router.transitionTo({
        queryParams: {
          tiktok_profile_mismatched: undefined
        }
      });
    }
    async connectProfile(socialProfile) {
      if (socialProfile.hasBusinessAccount && socialProfile.needsBusinessTokenRefresh) {
        this.connectBusinessAccount(socialProfile);
      } else {
        this.connectPersonalAccount(socialProfile);
      }
    }
    openInstagramAuthStatus() {
      this.instagramAuth.resetInstagramAuthStatusDates();
      this.set('showInstagramAuthStatus', true);
    }
    scrollToTag(tag) {
      const element = document.querySelector(tag);
      element.scrollIntoView({
        behavior: 'smooth'
      });
      this.hightlightComment.perform(element);
    }
    startEditingIdentityName(identity) {
      this.editingIdentityId = identity.id;
      this.editingIdentityName = identity.displayName || '';
    }
    cancelEditingIdentityName() {
      this.editingIdentityId = null;
      this.editingIdentityName = '';
    }
    updateEditingIdentityName(event) {
      // Limit to 25 characters
      const {
        value
      } = event.target;
      this.editingIdentityName = value.slice(0, 25);
    }
    handleEditKeydown(identity, event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.saveIdentityName.perform(identity);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        this.cancelEditingIdentityName();
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "mavelyAuth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "instagramAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "queryParams", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return ['showCredentialsWizard', 'source', {
        showCredentialsError: 'show_credentials_error'
      }, {
        showTiktokProfileMismatched: 'tiktok_profile_mismatched'
      }];
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "showContactUsModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "showCreatorProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "showCredentialsError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "showInstagramAuthStatus", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "showProfileAddedModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "showProfileCategorizationModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "showTiktokProfileMismatched", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "source", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 'account-settings';
    }
  }), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "editingIdentityId", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "editingIdentityName", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "mavelyProfilesForIdentity", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "mavelyProfilesForIdentity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canShowInstagramAuthStatus", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "canShowInstagramAuthStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteCreatorSocialSet", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteCreatorSocialSet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setup", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showErrors", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "showErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scrollTo", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "scrollTo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToCategorization", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToCategorization"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToAnalytics", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToAnalytics"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToCalendar", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToCalendar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeTikTokProfileMismatch", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeTikTokProfileMismatch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelTikTokProfileMismatch", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelTikTokProfileMismatch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openInstagramAuthStatus", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openInstagramAuthStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startEditingIdentityName", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "startEditingIdentityName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelEditingIdentityName", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelEditingIdentityName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateEditingIdentityName", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateEditingIdentityName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleEditKeydown", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleEditKeydown"), _class.prototype)), _class));
});